export enum GatResponseResultCategory {
  /** Info. */
  Info,
  /** The request was successful and the result is a payload. */
  Success,
  /** The request might include a payload. */
  Warning,
  /** The request was unsuccessfull and the result is not a payload. */
  Error,
}

export enum GatResponseResultType {
  Custom,
  Update_NoChanges,
  Update_OK,
  Update_Failed,
  Delete_OK,
  Delete_Failed,
  Delete_Abort_Constraint,
  No_Access,
}

export interface GatResponseResult<T> {
  message: string;
  /** The response result */
  payload?: T;
  syncChanges: any;
  resultType: GatResponseResultType;
  resultCategory: GatResponseResultCategory;
}
